/**
 * Login Page
 *
 * Full-screen centered login page with Piccard design.
 * Shows "Continue with Google" button to start OAuth flow.
 */

import { useState } from 'react'
import { useAuth } from '@/hooks/useAuth'

export function LoginPage() {
  const { login } = useAuth()
  const [isLoading, setIsLoading] = useState(false)

  const handleLogin = () => {
    setIsLoading(true)
    login()
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-[100dvh] bg-surface px-6">
      <div className="w-full max-w-sm">
        {/* Logo area */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-primary-container mb-4">
            <span className="material-symbols-outlined text-4xl text-on-primary-container">auto_awesome</span>
          </div>
          <h1 className="font-headline font-extrabold text-3xl text-primary mb-2">
            Piccard
          </h1>
          <p className="text-on-surface-variant text-base">
            Sign in to save your vocabulary to the cloud
          </p>
        </div>

        {/* Login card */}
        <div className="bg-surface-container-lowest rounded-2xl shadow-card p-8">
          <button
            onClick={handleLogin}
            disabled={isLoading}
            className="w-full flex items-center justify-center gap-3 px-6 py-4 rounded-2xl bg-surface-container-low hover:bg-surface-container transition-colors font-semibold text-on-surface disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {/* Google "G" SVG */}
            <svg width="20" height="20" viewBox="0 0 24 24">
              <path
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"
                fill="#4285F4"
              />
              <path
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                fill="#34A853"
              />
              <path
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                fill="#FBBC05"
              />
              <path
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                fill="#EA4335"
              />
            </svg>
            {isLoading ? 'Signing in...' : 'Continue with Google'}
          </button>
        </div>
      </div>
    </div>
  )
}
